import * as React from 'react';

import {Field} from 'redux-form';
// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {FormField} from 'shells/form/form-field';

import {RichAccountSelect} from './accounts/rich-account-select';
import {RichContactSelect} from './contacts/rich-contact-select';

type Props = FieldProps & {
    title?: string;
    helperText?: string;
    isRequired?: boolean;
    validate: (...args: any) => any;
};
export function RichPeepSelectField(props: Props) {
    const {title, helperText, isRequired, validate} = props;

    return (
        <FormField
            innerId={props.input.name}
            label={title}
            helperText={helperText}
            errorMessage={props.meta.error && props.meta.submitFailed ? props.meta.error : null}
            isRequired={isRequired}
            // @ts-expect-error
            validate={validate}
        >
            <Field
                name={props.input.name}
                component={props.title === 'Companies' ? RichAccountSelect : RichContactSelect}
                label={title}
                isRequired={isRequired}
                validate={validate}
            />
        </FormField>
    );
}
